import { AsyncPipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable } from 'rxjs';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';

@Component({
  selector: 'app-download-media-category-list',
  templateUrl: './download-media-category-list.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [AsyncPipe],
  standalone: false,
})
export class DownloadMediaCategoryListComponent implements OnChanges, OnInit {
  @Input() items: any;

  @Output() getDownloadCategry: EventEmitter<any> = new EventEmitter();

  activeCategory: any = 'All';
  activeCategoryTypeName: any = 'All';
  dropdownPosition = '';
  isMobile = this.deviceService.isMobile();

  constructor(
    private languageService: ShimanoLanguageService,
    private deviceService: DeviceDetectorService,
    private pipeAsync: AsyncPipe
  ) {}

  ngOnInit() {}

  clickDownloadCategory = (typeCode: string, typeName: string) => {
    this.getDownloadCategry.emit(typeCode);
    this.activeCategory = typeCode;
    this.activeCategoryTypeName = typeName;
  };

  sortData(data: string) {
    return this.items.types.sort((a: any, b: any) => (a[data] > b[data] ? 1 : a[data] === b[data] ? 0 : -1));
  }

  get activeLanguage$(): Observable<string> {
    return this.languageService.getActive();
  }

  ngOnChanges() {
    const selectedCategory = this.items.types.filter((data: any) => data.typeCode === this.activeCategory)[0];
    if (selectedCategory && this.activeCategoryTypeName !== selectedCategory.typeName) {
      this.activeCategoryTypeName = selectedCategory.typeName;
    }
  }
}
